export const formatDuration = (
  durationMinutes: number,
  includeSuffix: boolean = false,
): string => {
  const hours = Math.floor(durationMinutes / 60);
  const minutes = Math.round(durationMinutes % 60);
  const suffix = includeSuffix ? 'h' : '';

  return minutes === 0
    ? `${hours}${suffix}`
    : `${hours}:${('0' + minutes.toString()).substr(-2)}${suffix}`;
};
